// src/pages/Utilisateurs/PrepaPhysique/components/PrepaPhysiqueList.jsx

import React, { useState } from "react";

import PrepaPhysiqueExerciseCard from "./PrepaPhysiqueExerciseCard";
import PrepaPhysiqueExerciseSheet from "./PrepaPhysiqueExerciseSheet";

export default function PrepaPhysiqueList({
  adherent,
  exercices,
  savingKeys,
  onToggleExercise,
}) {
  const [openedExercise, setOpenedExercise] = useState(null);

  if (!Array.isArray(exercices) || exercices.length === 0) {
    return (
      <div className="rounded-2xl border border-dashed border-slate-300 bg-slate-50 p-5 text-center dark:border-slate-700 dark:bg-slate-950">
        <p className="text-sm font-semibold text-slate-500 dark:text-slate-400">
          Aucun exercice attribué pour le moment.
        </p>
      </div>
    );
  }

  return (
    <>
      <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
        {exercices.map((exercise) => {
          const savingKey = `${adherent.id}-${exercise.id}`;

          return (
            <PrepaPhysiqueExerciseCard
              key={exercise.id}
              adherent={adherent}
              exercise={exercise}
              saving={!!savingKeys[savingKey]}
              onOpen={() => setOpenedExercise(exercise)}
              onToggle={() => onToggleExercise(adherent.id, exercise)}
            />
          );
        })}
      </div>

      <PrepaPhysiqueExerciseSheet
        isOpen={!!openedExercise}
        adherent={adherent}
        exercise={openedExercise}
        saving={
          openedExercise
            ? !!savingKeys[`${adherent.id}-${openedExercise.id}`]
            : false
        }
        onClose={() => setOpenedExercise(null)}
        onToggle={() => {
          if (!openedExercise) return;
          onToggleExercise(adherent.id, openedExercise);
        }}
      />
    </>
  );
}